var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EmployeeHorizontalMenu,{attrs:{"menuItems":_setup.menuItems,"initialTab":_setup.activeLabel},on:{"tab-selected":_setup.onTabSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }